import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "cy:file:text-foreground cy:placeholder:text-muted-foreground cy:selection:bg-primary cy:selection:text-primary-foreground cy:dark:bg-input/30 cy:border-input! cy:flex cy:h-9 cy:w-full cy:min-w-0 cy:rounded-md cy:border cy:bg-transparent cy:px-3 cy:py-1 cy:text-base cy:shadow-xs cy:transition-[color,box-shadow] cy:outline-none cy:file:inline-flex cy:file:h-7 cy:file:border-0 cy:file:bg-transparent cy:file:text-sm cy:file:font-medium cy:disabled:pointer-events-none cy:disabled:cursor-not-allowed cy:disabled:opacity-50 cy:md:text-sm",
        "cy:focus-visible:border-ring cy:focus-visible:ring-ring/50 cy:focus-visible:ring-[3px]",
        "cy:aria-invalid:ring-destructive/20 cy:dark:aria-invalid:ring-destructive/40 cy:aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  )
}

export { Input }
